<div class="row">
  <div class="col-md-12">

    <div mat-dialog-title class="row">
      <div class="col-md-12">
        <strong> {{ data.title }}</strong>
      </div>
    </div>

    <div mat-dialog-content class="row">
      <div class="col-md-12">
        <div class="row">
          <div [innerHTML]="data.message"></div>
          </div>
      </div>
    </div>
    <div mat-dialog-actions class="row">
      <div class="col-md-12" style="text-align: center;">
        <button
          mat-raised-button
          (click)="onClickClose()">
            Ok
        </button>
      </div>
    </div>
  </div>
</div>
